import React, { PureComponent } from "react";
import { addTag, updateTag, removeTag } from '../../actions/tags';
// import { updateExistingProjectSelected, updateHasSelectedQuestions, updateNewPanelSelected } from '../../actions/_panel'
import { addQuestionIntoProject, removeQuestionFromProject } from './../../actions/projects'
import { store } from './../../store'
import { isObject } from './../../util';
import { convertTagValueToObject } from './../../util/index'

import _ from "lodash";
import "antd/dist/antd.css";
import { Modal, message, Radio } from "antd";
import striptags from "striptags";
import Dropzone from 'react-dropzone'

import MyQuestions from "../questionpanel/index";
import SearchBar from "./SearchBar";
import Tags from "./Tags";
import Results from "./Results";


import firebase from "firebase/app";

import mockTags from "./mockTags";
import config from '../../config';

import { reactLocalStorage } from 'reactjs-localstorage';



require("firebase/auth");
require("firebase/database");

var fbQuestionsPath = config.firebaseQuestionsPath

const confirm = Modal.confirm;
const RadioGroup = Radio.Group;
console.log('Select DB: ' + fbQuestionsPath)

class Dashboard extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      sourceData: [],
      searchKey: [],
      existingQuestionInfo: null,
      myQuestions: [],
      onQuestionCheck: { hasSelectedQuestions: 'false', onNewPanelSelected: 'true', onExistingProjectSelected: 'false' },
      tags: mockTags,
      totalQuestionsFromFiles: -1,
      metaSearchValue: '',
      initialSortedQuestion: null,
      totalTags: null,
      totalQuestions: null
    };

    if(config.realtime_site === 'true'){
      var tagRef = firebase.database().ref(fbQuestionsPath);
      tagRef.on("value", (snp) => {
        tagRef.transaction((snapshot) => {
          // console.log('transaction snapshot.. ', snapshot)
          if(snapshot){
            this.cleanFirebaseData(snapshot).then((incomingUpdated) => {
              this.setState({
                apiData: [incomingUpdated]
              });
            });
          }
        });
      }, (errorObject) => { console.log('errorObject: ', errorObject) });
    }
  }

  parseSQ(file) {
    function removeNewLine(txt){
      var noNewLine = txt.split("\n").join(" ");
      var noNBSP = noNewLine.split('&nbsp;').join(' ');
      return noNBSP.split(/\s+/).join(' ');
      // return txt.replace(/&nbsp;/gi, " ").replace(/\n/gi, "")
    }

    return new Promise((resolve, reject) => {
      this.getAllFromFirebase((success, data) => {
        var apiData = [];
        if(success){
          const json = JSON.parse(file);
          // console.log("json parseSQ:", json);
          const surveyID = json.SurveyEntry.SurveyID
          const res = json["SurveyElements"]
            .filter(function(o) {
              return o["Element"] === "SQ";
            });
          console.log('res length: ' + JSON.stringify(res));
          // debugger;
          let resUniq = _.uniqBy(res, o => removeNewLine(striptags(o.Payload.QuestionText)));
          console.log('resUniq length: ' + JSON.stringify(resUniq));
          // debugger;

          resUniq = _(resUniq).map(o => {
            const strip = striptags(o.Payload.QuestionText);
            const isMC = o.Payload.QuestionType === "MC";
            const isRanking = o.Payload.QuestionType === "RO";
            const isMatrix = o.Payload.QuestionType === "Matrix";
            const isSlider = o.Payload.QuestionType === "Slider";

            let answers = [{ answer: '' }];
            if (isMC || isRanking || isMatrix || isSlider) {
              // console.log(`${o.PrimaryAttribute} Choices:`, o.Payload.Choices);
              const choices = o.Payload.Choices;
              answers = Object.keys(choices)
                .map(o => {
                  // console.log("answer o:", choices[o].Display);
                  return { answer: (striptags(choices[o].Display).replace(/\n/gi, "")).trim(), tags: [] };
                })
                // .join("|");
            }
            var allQuestionsArray = _.values(data);
            let filtered = allQuestionsArray.filter((q) => {
              // console.log('removeNewLine(striptags(q.questionText)): ', removeNewLine(striptags(q.questionText)))
              // console.log('removeNewLine(striptags(o.Payload.QuestionText)): ', removeNewLine(striptags(o.Payload.QuestionText)))
              // console.log('(removeNewLine(striptags(q.questionText)) === removeNewLine(striptags(o.Payload.QuestionText))): ', (removeNewLine(striptags(q.questionText)) === removeNewLine(striptags(o.Payload.QuestionText))))
              let questionText = removeNewLine(striptags(q.questionText));
              let payloadQuestionText = removeNewLine(striptags(o.Payload.QuestionText));
              console.log('================');
              console.log('questionText: ', questionText);
              console.log('payloadQuestionText: ', payloadQuestionText);
              return ( questionText === payloadQuestionText)
            });
            // debugger;
            if(filtered.length === 0){
              return {
                surveyID: json.SurveyEntry.SurveyID,
                surveyName: json.SurveyEntry.SurveyName,
                id: o.PrimaryAttribute,
                questionType: o.Payload.QuestionType,
                questionText: removeNewLine(strip),
                hasMeta: false,
                answers
              };
            }else return null
          })
            .value();
          // console.log('res!!!' + JSON.stringify(_.compact(res)));
          apiData = _.compact(resUniq)
          if(apiData.length === 0) message.warning("You already imported this QSF Questions into database!")
          else message.success("You had successfully imported " + apiData.length + " new " + ( (apiData.length === 1) ? "question": "questions") + " into database!")
          resolve(apiData)
        }else{
          resolve(apiData)
        }
      })
    });
  }

  handleFiles(files) {
    // console.log(files);
    // const file = files[0];
    var totalQuestionsImported = [];
    files.map((file, ind) => {
      var reader = new FileReader();
      
      // Closure to capture the file information.
      reader.onload = ((theFile, totalQuestionsImported, ind, files) => {
        return e => {
          const json = JSON.parse(e.target.result);
          // Render thumbnail.
          // var span = document.createElement('span');
          // span.innerHTML = ['<img class="thumb" src="', e.target.result,
          //   '" title="', escape(theFile.name), '"/>'].join('');
          // document.getElementById('list').insertBefore(span, null);

          this.parseSQ(e.target.result).then((parsedFile) => {
            this.writeUserData(parsedFile);
            totalQuestionsImported.push(parsedFile.length)
            if(files.length ===  totalQuestionsImported.length) {
              // Once the files are completely loaded.
              totalQuestionsImported = totalQuestionsImported.reduce(function(a, b) { return a + b; }, 0);
              this.setState({ totalQuestionsFromFiles: totalQuestionsImported })
            }
          });
        };
      })(file, totalQuestionsImported, ind, files);

      // Read in the image file as a data URL.
      reader.readAsText(file);
    })
  }

  fetchQuestions() {
    console.log('fetchQuestions')
    const { searchKey } = this.state;
    const q = searchKey;
    this.getQuestions(q);
  }

  getTempSelectedQuestion() {
    let selectedQuestions = reactLocalStorage.getObject('selectedQuestions');
    if(!_.isEmpty(selectedQuestions)) {
      selectedQuestions = (selectedQuestions) ? selectedQuestions.selected: [];
      if(selectedQuestions.length > 0){
        this.setState({
          onQuestionCheck: Object.assign(this.state.onQuestionCheck, {
            hasSelectedQuestions: 'true'
          })
        })
      }else{
        this.setState({
          onQuestionCheck: Object.assign(this.state.onQuestionCheck, {
            hasSelectedQuestions: 'false'
          })
        })
      }
      this.setState({
        existingQuestionInfo: null,
        onExistingProjectSelected: 'false',
        onNewPanelSelected: 'true',
        myQuestions: selectedQuestions
      })
    }else reactLocalStorage.setObject('selectedQuestions', { selected: [] })
  }
  
  componentDidMount() {
    // console.log('componentDidMount')
    if (!firebase.apps.length) {
      firebase.initializeApp(config);
    }
    this.fetchQuestions();
    this.getTempSelectedQuestion()

    
  }

  componentDidUpdate(){
    console.log('this.props apiData: ', this.state.apiData);
    if(this.state.apiData){
      var totalQuestions = Object.values(this.state.apiData[0]);
      var totalTags = totalQuestions.filter(e => e.hasMeta === true);
      debugger;
      this.setState({
        totalTags: totalTags.length,
        totalQuestions: totalQuestions.length
      });
    }
  }

  componentWillReceiveProps (props){
    // console.log('will receive props')
    if(props.onExistingProjectSelected){
      let questions = (props.onExistingProjectSelected) ? _.values(props.onExistingProjectSelected.questions) : [];
      this.setState({
        existingQuestionInfo: _.omit(props.onExistingProjectSelected, ['questions']),
        myQuestions: questions,
        onQuestionCheck: Object.assign(this.state.onQuestionCheck, {
          onNewPanelSelected: 'false',
          onUpdateExistingProjectSelected: 'false'
        })
      })
    }

    if(props.isSiderClosed && props.onExistingProjectSelected === null){
      this.getTempSelectedQuestion()
    }
  }

  writeUserData = data => {
    // alert('writeUserData: ' + data)
    if(data) this.storeTagsInStore(data)

    setTimeout(() => {
      data.forEach(o => {
        o['timestamp'] = firebase.database.ServerValue.TIMESTAMP;

        firebase
          .database()
          .ref(fbQuestionsPath)
          .push()
          .set(o);
      });
      this.getQuestions();
    }, 100);
  };

  onSearchChange = value => {
    // const [searchKey = ""] = value;
    
    const { searchKey } = this.state;
    // console.log('value?? ', value)

    var removeStatus = false;
    if(value.length < searchKey.length) removeStatus = true;

    if(!removeStatus) {
      value.map((v) => {
        var upperVal = v.charAt(0).toUpperCase() + v.slice(1);
        if(!searchKey.includes(upperVal)){
          searchKey.push(upperVal)
        }
      })
    }

    // console.log('searchKey? ', searchKey)
    // const uppercaseKey = searchKey.charAt(0).toUpperCase() + searchKey.slice(1);
    const newTags = this.state.tags;
    if (searchKey.length > 0) {
      searchKey.map((sKey) => {
        var tagValues = newTags.map(a => a.text.charAt(0).toUpperCase() + a.text.slice(1))
        if(!tagValues.includes(sKey)) {
          var tagLatestID = tagValues[tagValues.length - 1].id;
          newTags.push({
            id: tagLatestID + 1,
            text: sKey
          });
        }
      })
    }
    // console.log('onSearchChange searchKey : ', searchKey)
    // console.log('onSearchChange value', value)
    // console.log('onSearchChange searchKey: ', searchKey)

    this.setState({
      searchKey: (removeStatus) ? value: searchKey,
      tags: newTags
    });
    this.forceUpdate()
    
    // this.getQuestions(currentSearch);
  };

  storeTagsInStore = (allQuestions) => {
    var allQuestionsType = Object.prototype.toString.call(allQuestions)
    var resQuestionTextTags = []
    if(allQuestionsType === "[object Object]") resQuestionTextTags = _.cloneDeep(_.values(allQuestions)) // retrieve from Firebase
    else resQuestionTextTags = _.cloneDeep(allQuestions) // imported from QSF

    var allTags = []
    if(resQuestionTextTags.length > 0){
      resQuestionTextTags.map((obj, ind) => {
        if(obj.tags) allTags = allTags.concat(_.values(obj.tags));
        if(obj.answers) {
          var answers = (allQuestionsType === "[object Array]") ? obj.answers: JSON.parse(obj.answers);
          let answerTags = answers.filter(ans => ans.tags).map((ans) => _.values(ans.tags));
          allTags = allTags.concat(_.flattenDeep(answerTags));
        }
        if(ind === resQuestionTextTags.length - 1){
          // store.dispatch(addTags(allTags))
          console.log('allTags: ' + JSON.stringify(_.uniq(allTags)))
          _.uniq(allTags).map((tg) => {
            store.dispatch(addTag(tg))
          })
        }
      })
    }
  }

  cleanFirebaseData = (resQuestionText) => {
    return new Promise((resolve, reject) => {
      for(var firebaseKey in resQuestionText){
        if (resQuestionText.hasOwnProperty(firebaseKey)) {
          resQuestionText[firebaseKey]['firebaseKey'] = firebaseKey
  
          let questionTags = resQuestionText[firebaseKey]['tags'];
          if(questionTags) {
            // console.log('questionTags... ' + JSON.stringify(questionTags))
            resQuestionText[firebaseKey]['tags'] = questionTags
          }
          // Stringify answers array into string
          var questionAnswers = _.values(resQuestionText[firebaseKey]['answers'])
          resQuestionText[firebaseKey] = {
            ...(resQuestionText[firebaseKey]),
            answers: JSON.stringify(questionAnswers)
          }
        }
      }
  
      // Store all the tags into redux store
      if(resQuestionText) this.storeTagsInStore(resQuestionText)
  
      /* Arrange latest questions first */
      let sorted = _.values(resQuestionText).sort((a,b) => {
          return a.timestamp < b.timestamp
      });
      var sortedQuestionText = {};
      for(var i = 0; i < sorted.length; i++) {
        sortedQuestionText[sorted[i].firebaseKey] = sorted[i] 
      }

      resolve(sortedQuestionText)
    });

    
  }

  getAllFromFirebase(cb){
    // console.log('fbQuestionsPath: ', fbQuestionsPath)

    var ref = firebase.database()
                .ref(fbQuestionsPath);
                
    ref.once("value", async(snapshot) => {
      const resQuestionText = snapshot.toJSON();
      // console.log('resQuestionText: ', resQuestionText)

      
      this.cleanFirebaseData(resQuestionText).then((initialSortedQuestion) => {
        // console.log('initialSortedQuestion.. ', initialSortedQuestion)
        this.setState({ initialSortedQuestion })
        cb(true, initialSortedQuestion)
      })
    }).catch((e) => {
      cb(false, JSON.stringify(e))
    })
  }

  getQuestions(searchKey) {
    this.getAllFromFirebase((success, data) => {
      if(success){
        // console.log('setState -> ', data)
        // success data
        this.setState({
          apiData: [data]
        });
      }else{ 
        // error data
        console.log(data)
      }
    })
  }

  onTagClick = tag => {
    // console.log('onTagClick')
    this.setState({ searchKey: tag });
  };

  onAddQuestion = q => {
    const { onQuestionCheck, existingQuestionInfo } = this.state;
    if(onQuestionCheck.onNewPanelSelected === 'false'){
      /**
       * 
       *  UPDATE EXISTING QUESTION FROM PROJECT
       * 
       */


      /* Add Project Question From Firebase */
      const projectID = existingQuestionInfo.id
      const projectQuestionID = q.id
      const projectQuestionSurveyID = q.surveyID
      const projectQuestionsRef = firebase
                                    .database()
                                    .ref(config.firebaseProjectsPath + projectID + '/questions')
                                    .child(projectQuestionSurveyID + '_' + projectQuestionID)
      projectQuestionsRef.set(q).then((err) => {
        if(!err){

          var existingQuestions = this.state.myQuestions;
          if(existingQuestions.length > 0) {
            let isFound = existingQuestions.filter(a => a.firebaseKey === q.firebaseKey);
            if(isFound.length === 0) {
              existingQuestions.push(q);
              message.success('Question added into project successfully!')
            } else message.warning("Failed to add. Duplication question!")
          } else {
            existingQuestions.push(q);
          }


          store.dispatch(addQuestionIntoProject(projectID, q))

          // console.log('newData', newData)
          // store.dispatch(addProject(newData))

          this.setState({
            myQuestions: existingQuestions
          })
          this.forceUpdate()

        }else{
          message.error('Failed to add question into project. Please try again later.')
        }
      })

    }else{
      /**
       * 
       *  CREATE NEW QUESTION
       * 
       */
      let existingProjectSelected = this.state.onQuestionCheck.onExistingProjectSelected;

      var selectedQuestions = (reactLocalStorage.getObject('selectedQuestions')).selected;
      if(selectedQuestions.length > 0) {
        let isFound = selectedQuestions.filter(a => a.firebaseKey === q.firebaseKey);
        if(isFound.length === 0) {
          selectedQuestions.push(q);
          message.success("Question had been added!");
        } else message.warning("Failed to add. Duplication question!")
      } else {
        selectedQuestions.push(q);
      }

      reactLocalStorage.setObject('selectedQuestions', { selected: selectedQuestions })

      // console.log("selectedQuestions", reactLocalStorage.get('selectedQuestions'))

      this.setState({
        myQuestions: (reactLocalStorage.getObject('selectedQuestions')).selected,
        onQuestionCheck: Object.assign(this.state.onQuestionCheck, { 
          hasSelectedQuestions: 'true'
        })
      });
    }
  }

  onRemoveQuestion = q => {
    const { onQuestionCheck, existingQuestionInfo } = this.state;
    if(onQuestionCheck.onNewPanelSelected === 'false') {
      /*
       * 
       *  UPDATE EXISTING QUESTION FROM PROJECT
       * 
       */


      /* Remove Project Question From Firebase */
      var projectID = existingQuestionInfo.id
      var projectQuestionID = q.id
      var projectQuestionSurveyID = q.surveyID
      var childKey = projectQuestionSurveyID + '_' + projectQuestionID
      setTimeout(() => {
        firebase
          .database()
          .ref(config.firebaseProjectsPath + projectID + '/questions/' + childKey)
          .remove((err) => {
            if(!err){
              var existingQuestions = this.state.myQuestions;
              var filteredQ = []
              if(existingQuestions.length > 0) {
                filteredQ = _.cloneDeep(
                  existingQuestions.filter((a) => a.firebaseKey !== q.firebaseKey)
                );
                message.success('Question removed into project successfully!')
              }

              store.dispatch(removeQuestionFromProject(projectID, q))
              this.setState({
                myQuestions: filteredQ
              })
              this.forceUpdate()

            }else message.error('There is a problem when remove. ' ,err)
          })
      },0);
    }else{
      /**
       * 
       *  CREATE NEW QUESTION
       * 
       */
      let selectedQuestions = (reactLocalStorage.getObject('selectedQuestions')).selected
      let filteredQ = selectedQuestions.filter(o => { return o.firebaseKey !== q.firebaseKey });
      reactLocalStorage.setObject('selectedQuestions', { selected: filteredQ });
      this.setState({
        myQuestions: filteredQ,
        onQuestionCheck: Object.assign(this.state.onQuestionCheck, { 
          hasSelectedQuestions: (filteredQ.length  > 0) ? 'true': 'false'
        })
      });
      message.success("Removed successfully!")
    }
    
  }

  onRemoveAllSelectedQuestions = () => {
    let selectedQuestions = (reactLocalStorage.getObject('selectedQuestions')).selected
    
    /* Reset all the default value */
    reactLocalStorage.setObject('selectedQuestions', { selected: [] })
    this.getTempSelectedQuestion()
  }

  onRemoveQuestionFromDB = q => {
    const { apiData } = this.state

    var confirmPrompt = null;
    function confirmPromise() {
      return new Promise((resolve, reject) => {
        confirmPrompt = confirm({
          title: 'Remove this question from database?',
          content: q.questionText,
          onOk(e) {
            // Remove from database
            firebase
              .database()
              .ref(fbQuestionsPath)
              .child(q.firebaseKey).remove((error) => {
                
                if(!error) {
                  var removedAPIData = _.cloneDeep(apiData)
                  delete removedAPIData[0][q.firebaseKey];
                  // console.log("removedAPIDATA removed:" + JSON.stringify(removedAPIData))
                  
                  // Log Remove Action Into Database
                  var logQ = _.cloneDeep(q);
                  logQ['action'] = config.log.ACTION_REMOVE_QUESTION;
                  logQ['timestamp'] = firebase.database.ServerValue.TIMESTAMP;
                  firebase
                    .database()
                    .ref(config.log.path)
                    .push()
                    .set(logQ);

                  resolve(removedAPIData)
                  return new Promise((resolve, reject) => {  resolve(); });
                }
                else message.error('Ops! There is something wrong on remove.');

                return new Promise((resolve, reject) => {  resolve(); });
            });
          },
          onCancel() { resolve(null) },
          okText: "Remove",
          cancelText: "Cancel",
          okType: "danger"
        })
      })
    }

    confirmPromise().then((apiData) => {
      if(apiData !== null){
        this.setState({ apiData: apiData })
        this.forceUpdate()
        message.success("Removed successfully!")
      }
      confirmPrompt.destroy()
    })
  }

  checkTags(question){
    let questionTagFound = false
    let answerTagFound = false
    let answerTags = []
    let questionTags = []

    if(question.answers){
      var answers = ((typeof question.answers) === "string") ? JSON.parse(question.answers) : question.answers;
      if(answers.length > 0) {
        answerTags = answers
                        .filter(ans => {
                          return (ans.tags) ? (ans.tags.length > 0): false
                        })
        if(answerTags.length > 0) answerTagFound = true;
      }
    }

    if(question.tags){
      questionTags = _.values(question.tags).filter((obj) => { return obj });
      if(questionTags.length > 0) questionTagFound = true;
    }

    if(answerTagFound === true || questionTagFound === true){
      return Promise.resolve(true)
    }else return Promise.resolve(false)
  }

  updateHasMeta = (refParam, hasMeta) => {
    firebase
      .database()
      .ref(refParam)
      .update({ hasMeta: hasMeta });
  }
  
  onHandleQuestionTags = (qData, tag, status)=> {
    var refParam = fbQuestionsPath + qData.firebaseKey;

    // console.log('Question tag... ' + JSON.stringify(tag))
    // console.log('Status... ' + status)

    if(status === 'remove') {
      /* Remove Question Tag From Firebase */
      // console.log('ref... ' + refParam + 'tags/' + tag.val)
      firebase
        .database()
        .ref(refParam + '/tags/' + tag.val)
        .remove((err) => {
          if(!err){
            message.success('Question tag had been removed into project successfully!')

            let removedInd = store.getState().tags.findIndex(a => {
              if(!isObject(a)) a === tag.val
            })
            store.dispatch(removeTag(removedInd))
            var newDataRef = firebase.database().ref(refParam);
            newDataRef.once("value", (snapshot) => {
              this.checkTags(snapshot.val()).then((found) => {
                this.updateHasMeta(refParam, found)
              })
            }, (errorObject) => { });
          }else message.error('There is a problem when remove. ' ,err)
        })
    
    }else if(status === 'edit'){
      /* Update Question Tag */
      firebase
        .database()
        .ref(refParam + '/tags/' + tag.oldVal)
        .remove((err) => {
          if(!err){
            var query = firebase
                      .database()
                      .ref(refParam)
                      .child("tags/" + tag.newVal)

            query.set(tag.newVal).then((err) => {
              if(!err) {
                message.success('Question tag had been updated into project successfully!')

                let updatedInd = store.getState().tags.findIndex(a => {
                  if(!isObject(a)) a === tag.oldVal
                })
                // alert('updatedInd: ' + updatedInd)
                store.dispatch(updateTag(tag.newVal, updatedInd))
              }
            })
          }else message.error('There is a problem when remove. ', err)
        })
    }else{
      /* Add Question Tag */
      const questionTagsRef = firebase
                                  .database()
                                  .ref(refParam)
                                  .child("tags/" + tag.val)

      questionTagsRef.set(tag.val).then((err) => {
        if(!err){
          message.success('Question tag added!')

          store.dispatch(addTag(tag.val))
          var newDataRef = firebase.database().ref(refParam);
          // debugger;
          newDataRef.once("value", (snapshot) => {
            // debugger;
            this.checkTags(snapshot.val()).then((found) => {
              // console.log('checkTags found on create: ' + found)
              this.updateHasMeta(refParam, found)
              // debugger;
            })
          }, (errorObject) => { });
        }else{
          message.error('Failed to add question into project. Please try again later.')
        }
      })
    }
  }

  onHandleQuestionAnswerTags = (qData, tag, answerIndex, status) => {
    let questionAnswers = qData.answers;

    // console.log('qData -> ' + JSON.stringify(qData))
    // console.log('tags -> ', tag)
    // console.log('Status... ' + status)
    // console.log('answerIndex -> ', answerIndex)
    debugger;
    var refParam = fbQuestionsPath + qData.firebaseKey;
    
    if(status === 'remove') {
      /* Remove Question Answer Tag From Firebase */
      // console.log(refParam + '/answers/' + answerIndex + '/tags/' + tag.val)
      setTimeout(() => {
        firebase
          .database()
          .ref(refParam + '/answers/' + answerIndex + '/tags/' + tag.val)
          .remove((err) => {
            if(!err){
              
              message.success('Question answer tag had been removed into project successfully!')
              let removedInd = store.getState().tags.findIndex(a => {
                if(!isObject(a)) a === tag.val
              })
              store.dispatch(removeTag(removedInd))

              var newDataRef = firebase.database().ref(refParam);
              newDataRef.once("value", (snapshot) => {
                this.checkTags(snapshot.val()).then((found) => {
                  this.updateHasMeta(refParam, found)
                })
              }, (errorObject) => { console.log("The read failed: " + errorObject.code);});
            }else message.error('There is a problem when remove. ' ,err)
          })
      },0)
    }else if(status === 'edit') {
      /* Edit Question Answer Tag From Firebase */
      // console.log('edit.. ' + refParam + '/answers/' + answerIndex + '/tags/' + tag.oldVal)
      setTimeout(() => {
      firebase
        .database()
        .ref(refParam + '/answers/' + answerIndex + '/tags/' + tag.oldVal)
        .remove((err) => {
          if(!err){
            
            var query = firebase
                          .database()
                          .ref(refParam + '/answers/' + answerIndex)
                          .child("tags/" + tag.newVal)
            let updatedInd = store.getState().tags.findIndex(a => {
              if(!isObject(a)) a === tag.oldVal
            })
            store.dispatch(updateTag(tag.newVal, updatedInd))
            query.set(tag.newVal).then((err) => {
              if(!err) {  message.success('Question answer tag had been updatd into project successfully!') }
            })
          }else message.error('There is a problem when remove. ', err)
        })
      },100)
    }else {
      /* Add Question Answer Tag From Firebase */
      const questionTagsRef = firebase
                                .database()
                                .ref(refParam + '/answers/' + answerIndex)
                                .child("tags/" + tag.val)
      
      questionTagsRef.set(tag.val).then((err) => {
        if(!err){
          message.success('Question answer tag added!')
          store.dispatch(addTag(tag.val))
          var newDataRef = firebase.database().ref(refParam);
          newDataRef.once("value", (snapshot) => {
            // console.log('newDataRef snapshot -> ' + JSON.stringify(snapshot.val()))
            this.checkTags(snapshot.val()).then((found) => {
              this.updateHasMeta(refParam, found)
            })
          }, (errorObject) => { console.log("The read failed: " + errorObject.code); });
        }else{
          message.error('Failed to add answer tag into project. Please try again later.')
        }
      })
    }
    

    // var refParam = fbQuestionsPath + qData.firebaseKey;
    // setTimeout(() => {
    //   firebase
    //     .database()
    //     .ref(refParam + '/answers/' + answerIndex)
    //     .update({ tags: tags })
    //     .then(() => {
    //       message.success("Tag had been updated successfully.")
    //       var newDataRef = firebase.database().ref(refParam);
    //       newDataRef.once("value", (snapshot) => {
    //         this.checkTags(snapshot.val()).then((found) => {
    //           this.updateHasMeta(refParam, found)
    //         })
    //       }, (errorObject) => {
    //         console.log("The read failed: " + errorObject.code);
    //       });
    //     })
    //     .catch((error) => { message.error("Ops! Failed to update tag! ", error) });
    // },250)
  }

  onMetaChange = (e) => { 
    this.setState({ metaSearchValue: e.target.value })
  }

  setQuestionData = (questions) => {
    this.setState({
      myQuestions: questions
    })
    reactLocalStorage.setObject('selectedQuestions', { selected: [] })
    this.getTempSelectedQuestion()
  }

  render() {
    const { totalQuestions, totalTags, searchKey, apiData, tags, myQuestions, onQuestionCheck, totalQuestionsFromFiles, metaSearchValue, existingQuestionInfo } = this.state;

    return (
      <div style={{ textAlign: "center" }}>
        <Dropzone 
          style={{ position: "relative",
          padding: 20,
          margin: 20,
          border: '1px solid #000' }}
        onDrop={this.handleFiles.bind(this)}>
          <p>Try dropping some files here, or click to select files to upload.</p>
        </Dropzone>
      {/*
      */}
        <SearchBar value={searchKey} onSearchChange={this.onSearchChange} />
        <Tags data={tags} onTagClick={this.onTagClick} />

        <div style={{ padding:"20px", marginBottom: "30px" }}>
          <h2 style={{ color:"grey"}}>Tag Filter</h2>
          <RadioGroup onChange={this.onMetaChange} value={metaSearchValue}>
            <Radio value={''}>All</Radio>
            <Radio value={true}>With Tag</Radio>
            <Radio value={false}>Without Tag</Radio>
          </RadioGroup>
          <div style={{ marginTop: "20px" }} >Tagged Questions: <strong>{totalTags} / {totalQuestions}</strong></div>
        </div>
       

        <Results
          filteredHasMeta={metaSearchValue}
          totalQuestionsFromFiles = {totalQuestionsFromFiles}
          searchKey={searchKey}
          data={apiData}
          onAdd={this.onAddQuestion}
          onRemove={this.onRemoveQuestionFromDB}
          handleQuestionTags={this.onHandleQuestionTags.bind(this)}
          handleQuestionAnswerTags={this.onHandleQuestionAnswerTags.bind(this)}
        />
        <div>&nbsp;</div>
        <MyQuestions
          existingQuestionInfo={existingQuestionInfo}
          data={myQuestions}
          setData={this.setQuestionData.bind(this)}
          onRemove={this.onRemoveQuestion} 
          onQuestionCheck={onQuestionCheck}
          onRemoveAllSelectedQuestions={this.onRemoveAllSelectedQuestions.bind(this)}/>
        {/*
        */}
      </div>
    );
  }
}

export default Dashboard




// WEBPACK FOOTER //
// ./src/components/dashboard/index.js